/* hs-eslint ignored failing-rules */
/* eslint-disable react/prop-types */

'use es6';

import PropTypes from 'prop-types';
import { Fragment, useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import CloseConversationTourStep from './CloseConversationTourStep';
import { getClickedModalCta } from '../../prompts/constants/Events';
import { ActionButton } from '../../thread-toolbar/components/ActionButton';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';

/**
 * This component is deprecated and should be replaced with the CloseOrReopenConversationButton
 * component, after ungating status syncing.
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CloseConversationButton = props => {
  const {
    isClosingCurrentConversation,
    isActiveBotConversation,
    disabled,
    className,
    onClick,
    hasAssociatedTickets
  } = props;
  const closeConversation = useCallback(() => {
    onClick({
      hasAssociatedTickets
    });
    trackEvent(getClickedModalCta({
      ctaAction: 'confirmed',
      subscreen2: 'close-thread-prompt'
    }));
  }, [onClick, hasAssociatedTickets]);
  if (isClosingCurrentConversation) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      size: "extra-small",
      use: "tertiary-light"
    });
  }
  const buttonDisabled = isActiveBotConversation || disabled;
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx(CloseConversationTourStep, {
      children: /*#__PURE__*/_jsxs(ActionButton, {
        className: `selenium-test-marker-close-thread-button ${className}`,
        onClick: closeConversation,
        disabled: buttonDisabled,
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "success",
          size: 12
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-thread-view.thread-toolbar.closeConversationBtn.closeCvText"
        })]
      })
    })
  });
};
CloseConversationButton.displayName = 'CloseConversationButton';
CloseConversationButton.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  isActiveBotConversation: PropTypes.bool.isRequired,
  isClosingCurrentConversation: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};
export default CloseConversationButton;